export const InputDataEditSessionUrl = {
  open: '/input-data/edit-sessions',
  hasPendingDrafts: '/input-data/edit-sessions/{sessionId}/has-pending-drafts',
  discard: '/input-data/edit-sessions/{sessionId}',
  rows: '/input-data/edit-sessions/{sessionId}/rows',
  validateRow: '/input-data/edit-sessions/{sessionId}/validate-row',
  commit: '/input-data/edit-sessions/{sessionId}/commit',
  excelUpload: '/input-data/edit-sessions/{sessionId}/excel',
} as const;
